import { subscriptionCollection, Timestamp } from '@/db/firestore';
import { SubscriptionModel } from '@/models/subscription';
export class Subscriptions {
    public addUserSub(userId: string, planId: string): Promise<firebase.firestore.DocumentReference> {
        const thisSub: SubscriptionModel = {
            userId,
            planId,
            active: true,
            createdAt: Timestamp.now(),
            lastUpdatedAt: Timestamp.now(),
        };

        return subscriptionCollection.add(thisSub);
    }

    public getUserSubs(userId: string) {
        return subscriptionCollection.where('userId', '==',  userId).orderBy('active', 'desc');
    }

    public getUserSubsAsync = async (userId: string) => {
        const subQuery = subscriptionCollection.where('userId', '==',  userId).orderBy('active', 'desc');
        const subs = await subQuery.get().then((snapshot) => { const subs = snapshot.docs.map((sub) => sub.data()); return subs; })
        return subs;
    }
}